module.exports = __webpack_public_path__ + "world-cup.embedded.svg?f2cb2863f44dbce30b538a7a3cb84fdb";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/world-cup.embedded.svg
// module id = 1256
// module chunks = 20